<template>
  <div v-id="jsonData != null">
    <div v-if="typeof jsonData.process_results != 'undefined'">
      {{$t('Total Tickets')}}:
      <strong>
        {{jsonData.process_results.total_tickets}}
        {{$t("tickets")}}
      </strong>
      |
      {{$t('Lost')}}:
      <strong>
        {{jsonData.process_results.tickets_lost}}
        {{$t("tickets")}}
      </strong>
      |
      {{$t('Won')}}:
      <strong>
        {{jsonData.process_results.tickets_won}}
        {{$t("tickets")}}
      </strong>
      |
      {{$t('Stake')}}:
      <strong>{{jsonData.process_results.total_stake}}</strong>
      |
      {{$t('Stake Lost')}}:
      <strong>{{jsonData.process_results.total_stake_lost}}</strong>
      |
      {{$t('Winning Amount')}}:
      <strong>{{jsonData.process_results.total_win_amount}}</strong>
      |
      {{$t('Winning Tax')}}:
      <strong>{{jsonData.process_results.total_win_tax}}</strong>
    </div>
    <div
      v-if="typeof jsonData.results != 'undefined'"
    >{{$t('Results')}}: {{ jsonData.results.join(",") }}</div>
    <div v-if="typeof jsonData.id != 'undefined'">
      {{$t('Event')}}:
      <router-link :to="`/lottery-events/${jsonData.id}`">{{ eventName }}</router-link>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["json"],
  data() {
    return {
      jsonData: {}
    };
  },
  computed: {
    eventName() {
      if (this.jsonData && this.jsonData.name) {
        if (this.jsonData.schedule_time) {
          return `${this.jsonData.name} ${this.mom_unix(
            this.jsonData.schedule_time
          ).format("DD-MM-YY, HH:mm")}`;
        } else {
          return this.jsonData.name;
        }
      }
      return this.jsonData && this.jsonData.id ? this.jsonData.id : "";
    }
  },
  mounted() {
    if (this.json) {
      try {
        this.jsonData = JSON.parse(this.json);
      } catch (err) {
        //noop
      }
    }
  },
  methods: {
    mom_unix(val) {
      return moment.unix(parseInt(val / 1e9));
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
